import consumer from './consumer';

let analyticsTeamSubscription = null;

export function subscribeTo(analyticsTeamId) {
  if (analyticsTeamSubscription) {
    analyticsTeamSubscription.unsubscribe();
  }

  analyticsTeamSubscription = consumer.subscriptions.create(
    { channel: 'AnalyticsTeamChannel', analytics_team_id: analyticsTeamId },
    {
      received(data) {
        if (data.type === 'activity') {
          const feed = document.getElementById('analytics-team-feed');
          if (feed) {
            feed.insertAdjacentHTML('beforeend', data.html);
            feed.scrollTop = feed.scrollHeight;
          }
        }

        if (data.type === 'team_status') {
          document.dispatchEvent(
            new CustomEvent('analytics-team:status', { detail: data })
          );
        }

        if (data.type === 'report_ready') {
          document.dispatchEvent(
            new CustomEvent('analytics-team:report', { detail: data })
          );
        }
      }
    }
  );

  return analyticsTeamSubscription;
}

export default { subscribeTo };
